import React, { useEffect } from "react";
import Img from "../../molecules/Img";
import imagedetails from "../../../assets/pics/detailsimage.jpg";
import Button from "../../atoms/Button/Button";
import { GoArrowLeft } from "react-icons/go";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Newsdetailssection({ data }) {
  // console.log("data in the news details==========>>>",data)
  const { id } = useParams(); // Get the `id` from the URL
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isArabic = (i18n.language?.split("-")[0] || "ar") === "ar";
  const title = isArabic ? data?.titleA : data?.titleE;
  const description = isArabic ? data?.descriptionA : data?.descriptionE;
  const date = isArabic ? data?.createDate : data?.createDateE;
  const noData = t("common.noData");
  // const location = useLocation()

  useEffect(() => {
    // You can use the `id` to fetch additional data from the backend if needed
    // console.log("Fetched ID:", id);
  }, [id]);

  // console.log('location', location)

  // but this when user goes with the flow from all news pieces.
  // const { newsData } = location.state || {}; // Destructure `newsData` from state
  // console.log('newsData', newsData)

  const onAllBtnClick = () => {
    // console.log("beooooooooooo")
    navigate("/allnews");
  };

  const newsLink = data?.link;
  //   const onNewsLinkClick = (link) => {
  //     console.log("clicked", link);
  //     window.open(link, "_blank", "noopener,noreferrer");
  //   };

  const onNewsLinkClick = (link) => {
    console.log("clicked", link);

    const formattedLink =
      link.startsWith("http://") || link.startsWith("https://")
        ? link
        : `https://${link}`;

    window.open(formattedLink, "_blank", "noopener,noreferrer");
  };
  return (
    <div className="h-full bg-rd-200 mt-20 flex flex-col justify-center items-center">
      <div className="h-full bg-rd-400 w-5/6 md:w-2/3 mb-[30px]">
        <div className="flex flex-col justify-center items-start bg-bue-400 mb-[10px] bg-ed-400">
          <div className="mb-[10px] font-cairo-bold bg-ed-500 text-start">
            {/* <div>استجابة سريعة لسرقة لوحة حمدي قنديل(عاش هنا) من وزارة الثقافة</div> */}
            <div>{title || noData}</div>
          </div>
          <div className="flex flex-col justify-center items-start bg-bue-600">
            <div className="font-tajawal-regular text-[#50739F] text-[15px]">
              {date || noData}
            </div>
            {/* <div className='font-cairo-regular text-[#02234D] text-[15px]'>الصورة بواسطة المركز الاعلامي لوزارة الثقافة</div> */}
          </div>
        </div>
        <div>
          <div>
            <Img
              // src={imagedetails}
              src={data?.image}
              alt={title}
              bigrectangular
            />
          </div>
          {description ? (
            <div className="font-cairo-regular pt-4 pb-2 text-start">
              {description}
            </div>
          ) : null}
          <div
            className="font-cairo-regular pb-4 text-start text-amber cursor-pointer underline underline-offset-4"
            onClick={() => onNewsLinkClick(newsLink)}
          >
            {t("news.details.link")}
            {/* <Button  primary rounded onClick={()=>onNewsLinkClick("https://www.facebook.com/profile.php?id=100063829523142")}>رابط الخبر</Button> */}
          </div>
        </div>

        <div>
          <div className="">
            <Button primary rounded blackText onClick={onAllBtnClick}>
              {t("news.details.allNews")}
              <GoArrowLeft className="ms-[15px] text-black ltr:rotate-180" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
